import React, { useEffect, useMemo, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import validate from 'validate.js';
import PropTypes from 'prop-types';
import { makeStyles } from '@mui/styles';
import { enqueueSnackbar } from 'actions';
import clsx from 'clsx';
import moment from 'moment';
import {
	Button, TextField, Card, Grid, CardHeader,
	CardContent, Tabs, Tab, Typography, Box, Divider,
	FormControlLabel, Checkbox
} from '@mui/material';
import _ from 'underscore';
import { SelectField } from 'components';
import DatePicker from 'components/DatePicker/DatePicker';
import DateTimePicker from 'components/DatePicker/DateTimePicker';
import TimePicker from 'components/DatePicker/TimePicker';

import { SetFormState, GetClustersNames, GetClusterDetails } from '../../actions/ReportsKpisActions';

const schema = {
	siteId: {
		presence: { allowEmpty: false, message: 'is required' }
	},
	// date: {
	// 	presence: { allowEmpty: false, message: 'is required' }
	// },
	// status: {
	// 	presence: { allowEmpty: false, message: 'is required' }
	// }
};

const useStyles = makeStyles(theme => ({
	root: {},
}));

const ReportsKpisDialogForm = (props) => {
	const { className, ...rest } = props;
	const classes = useStyles();
	const dispatch = useDispatch();
	const setFormState = formState => dispatch(SetFormState(formState));
	const formState = useSelector(state => state.reportsKpisRanReducer.formState);
	const userId = useSelector(state => state.session.user.id);
	const userRole = useSelector(state => state.session.user.role);
	const _hasError = field => !!(formState.touched[field] && formState.errors[field]);
	const clustersNames = useSelector((state) => state.reportsKpisRanReducer.clustersNames);

	const _handleChange = event => {

		setFormState({
			...formState,
			values: {
				...formState.values,
				[event.target.name]:
					event.target.type === 'checkbox'
						? event.target.checked
						: event.target.value
			},
			touched: {
				...formState.touched,
				[event.target.name]: true
			}
		});
	};

	useMemo(() => {
		setFormState({
			...formState,
			values: {
				...formState.values,
				'clusterName': undefined
			}
		});
	}, [clustersNames]);

	return (
		<div {...rest} className={clsx(classes.root, className)}>
			<Grid container spacing={2}>
				<Grid item md={12} xs={12}>
					<Card>
						<CardHeader title="Reports" style={{ paddingBottom: 0 }} />
						<CardContent>
							<Grid container spacing={2}>
								<Grid item md={2} xs={2}>
									<SelectField
										id="clusterName"
										name="clusterName"
										hintText="Cluster Name"
										defaultValue=""
										menuItems={(clustersNames) || []}
										value={formState.values.clusterName}
										onChange={_handleChange}
										sx={{
											'& .MuiInputBase-input': {
												backgroundColor: 'white',
												'&.Mui-disabled': {
													color: 'dimGray',
													WebkitTextFillColor: 'dimGray'
												}
											},
										}}
									/>
								</Grid>
							</Grid>
						</CardContent>
					</Card>
				</Grid>
			</Grid>
		</div >
	);
};

ReportsKpisDialogForm.propTypes = {
	className: PropTypes.string
};

export default ReportsKpisDialogForm;
